import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Pass from "components/Cards/CardProfile.js";
import ProfileUpload from "./AcProfileUpload";

export default function CardSettings() {
  window.localStorage.removeItem("userdata");
  // const [profile, setprofile] = useState([]);
  const [edituser, setedituser] = useState([]);
  const [error, SetError] = useState(false);
  const [state, setState] = React.useState({
    username: "",
    password: "",
    groups: "",
    organization_name: "",
    address: "",
    country: "",
    currency: "INR",
    username1: window.localStorage.getItem("user"),
    email: window.localStorage.getItem("email"),
  });
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/user_management/getprofile`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setedituser(resp));
  }, []);
  // useEffect(() => {
  //   fetch(
  //     `${process.env.REACT_APP_API_URL}/api/user_management/profilemanage/`,
  //     {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + window.localStorage.getItem("token"),
  //       },
  //     }
  //   )
  //     .then((resp) => resp.json())
  //     .then((resp) => setprofile(resp[0]))
  //     .catch((error) => {
  //       console.error(error);
  //       window.location.href = "/something_went_wrong";
  //     });
  // }, []);

  const handleEditChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const Submit = (e) => {
    e.preventDefault();
    const usrprofile = {
      username: state.username,
      password: state.password,
      groups: state.groups,
      organization_name: state.organization_name,
      address: state.address,
      country: state.country
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/user_management/editprofile`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(usrprofile),
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        window.location.reload();
      });
  };

  const [avatar, setAvatar] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/usrimage/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setAvatar(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-8/12 px-4">
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0" style={{border: 'groove'}}>
            <div className="rounded-t bg-white mb-0 px-6 py-6">
              <div className="text-center flex justify-between">
                <h6 className="text-blueGray-700 text-xl font-bold">
                  Edit Profile
                </h6>
              </div>
              <hr className="mt-6 border-b-1 border-blueGray-500" />
            </div>
            <div className="flex-auto bg-white px-4 lg:px-10 py-10 pt-0">
              <form>
                <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
                  User Information
                </h6>
                <div className="flex flex-wrap">
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block text-blueGray-600 text-sm font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Name
                      </label>
                      <TextField
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        onChange={handleEditChange}
                        id="username"
                        variant="outlined"
                        value={state.username}
                        placeholder={edituser.username}
                        size="small"
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block text-blueGray-600 text-sm font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Email address
                      </label>
                      <TextField
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        disabled
                        onChange={handleEditChange}
                        id="email"
                        variant="outlined"
                        value={state.email}
                        placeholder={edituser.email}
                        size="small"
                        variant="filled"
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block text-blueGray-600 text-sm font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Group name
                      </label>
                      <TextField
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        disabled
                        onChange={handleEditChange}
                        id="groups"
                        variant="outlined"
                        value={state.groups}
                        placeholder={edituser.group}
                        variant="filled"
                        size="small"
                      />
                    </div>
                  </div>

                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <Pass />
                    </div>
                  </div>
                </div>

                <hr className="mt-6 border-b-1 border-blueGray-300" />

                <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
                  Organization Information
                </h6>
                <div className="flex flex-wrap">
                  <div className="w-full lg:w-12/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block text-blueGray-600 text-sm font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Organization Name
                      </label>
                      <TextField
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        disabled
                        onChange={handleEditChange}
                        id="organization_name"
                        variant="outlined"
                        value={state.organization_name}
                        placeholder={edituser.organization}
                        variant="filled"
                        size="small"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap">
                  <div className="w-full lg:w-12/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block text-blueGray-600 text-sm font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Address
                      </label>
                      <TextField
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        onChange={handleEditChange}
                        id="address"
                        variant="outlined"
                        value={state.address}
                        placeholder={edituser.address}
                        size="small"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap">
                  <div className="w-full lg:w-12/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block text-blueGray-600 text-sm font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Country
                      </label>
                      <TextField
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        onChange={handleEditChange}
                        id="country"
                        variant="outlined"
                        value={state.country}
                        placeholder={edituser.country}
                        size="small"
                      />
                    </div>
                  </div>
                </div>  
                <div className="flex flex-wrap">
                  <div className="w-full lg:w-12/12 px-4">
                    <div className="relative w-full mb-3">
                      <label
                        className="block text-blueGray-600 text-sm font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Currency
                      </label>
                      <TextField
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        onChange={handleEditChange}
                        id="currency"
                        variant="outlined"
                        value={state.currency}
                        placeholder={edituser.currency}
                        disabled
                        variant="filled"
                        size="small"
                      />
                    </div>
                  </div>
                </div>                                
                <div className="rounded-t mb-0 px-6 py-6">
                  <div className="text-center flex justify-between">
                    <button
                      className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={Submit}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-4/12 px-4">
          <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg mt-16">
            <div className="px-6">
              <div className="flex flex-wrap justify-center">
                <div className="w-full px-4 flex justify-center">
                  <div className="relative">
                    <img
                      alt="..."
                      src={
                        avatar
                          ? avatar.cover
                          : require("assets/img/theme/userimg.png").default
                      }
                      className="shadow-xl rounded-full h-auto align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px"
                    />
                  </div>
                </div>
              </div>
              <div className="text-center mt-12">
                <h3 className="text-xl font-semibold leading-normal mb-2 text-blueGray-700 mb-2">
                  {edituser.username}
                </h3>
                <div className="text-sm leading-normal mt-0 mb-2 text-blueGray-400 font-bold">
                  {edituser.email}
                </div>
                <div className="text-sm font-semibold leading-normal mt-0 mb-2 text-blueGray-700">
                  {edituser.address}
                </div>
                <div className="mt-8 py-8 border-t border-blueGray-200 text-center"></div>
                <ProfileUpload />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
